// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f12b1f0f","453":"343bc53f"}[chunkId] + ".chunk.js";
};